import React from 'react'

const SmallLoader = () => (
  <div className="small-loader">
    <img src="/assets/images/loader.gif" alt="Loader" />
  </div>
)

export default SmallLoader



// WEBPACK FOOTER //
// ./src/browser/components/SmallLoader.js